// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"3daebc50","787":"ec704a7a"}[chunkId] + ".chunk.js";
};